import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _get from "@babel/runtime/helpers/get";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
import { SSRGetDoneMark } from '../helper/ssr-get-done-mark';
import { PageSegmentPageLoadMetricsOptions } from '../types';
import { MetricState } from './base-metric';
import { Metric } from './metric';
import { pageLoadMetaMetric } from './page-load-meta-metric';
export var PageSegmentLoadMetric = /*#__PURE__*/function (_Metric) {
  function PageSegmentLoadMetric(config) {
    var _this;
    _classCallCheck(this, PageSegmentLoadMetric);
    _this = _callSuper(this, PageSegmentLoadMetric, [config]);
    _defineProperty(_this, "isInitial", true);
    _this.config = config;
    return _this;
  }
  _inherits(PageSegmentLoadMetric, _Metric);
  return _createClass(PageSegmentLoadMetric, [{
    key: "startFromPageLoad",
    value: function startFromPageLoad() {
      var _pageLoadMetaData$sta;
      var pageLoadMetaData = pageLoadMetaMetric.getData();
      this.start({
        startTime: (_pageLoadMetaData$sta = pageLoadMetaData.start) !== null && _pageLoadMetaData$sta !== void 0 ? _pageLoadMetaData$sta : undefined
      });
      this.isInitial = pageLoadMetaData.isInitial;
      this.pageVisibleState = pageLoadMetaData.pageVisibleState;
    }
  }, {
    key: "mark",
    value: function mark(_mark) {
      var timestamp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.performance.now();
      if (_mark === PageSegmentLoadMetric.FMP) {
        return;
      }
      _superPropGet(PageSegmentLoadMetric, "mark", this, 3)([_mark, timestamp]);
    }
  }, {
    key: "markFMP",
    value: function markFMP(timestamp) {
      _superPropGet(PageSegmentLoadMetric, "mark", this, 3)([PageSegmentLoadMetric.FMP, timestamp]);
    }
  }, {
    key: "getPageSegmentLoadData",
    value: function getPageSegmentLoadData() {
      return {
        isInitial: this.isInitial
      };
    }
  }, {
    key: "getData",
    value: function getData() {
      return _objectSpread(_objectSpread({}, _superPropGet(PageSegmentLoadMetric, "getData", this, 3)([])), this.getPageSegmentLoadData());
    }
  }, {
    key: "getDataToMerge",
    value: function getDataToMerge() {
      return _objectSpread(_objectSpread({}, _superPropGet(PageSegmentLoadMetric, "getDataToMerge", this, 3)([])), this.getPageSegmentLoadData());
    }
  }, {
    key: "merge",
    value: function merge(mergeData) {
      _superPropGet(PageSegmentLoadMetric, "merge", this, 3)([mergeData]);
      this.isInitial = mergeData.isInitial;
    }
  }, {
    key: "stop",
    value: function stop() {
      var _this$config$ssr,
        _this2 = this;
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var pageLoadData = pageLoadMetaMetric.getData();
      if (pageLoadData.isInitial && (_this$config$ssr = this.config.ssr) !== null && _this$config$ssr !== void 0 && _this$config$ssr.doneAsFmp) {
        if (!this.marks[PageSegmentLoadMetric.FMP]) {
          var mark = SSRGetDoneMark.getDoneMark();
          if (mark) {
            this.markFMP(mark);
          }
        }
      }
      if (this.config.includePageLoadTimings !== PageSegmentPageLoadMetricsOptions.WAIT_UNTIL_PRESENT || pageLoadData.state === MetricState.FINISHED) {
        return _superPropGet(PageSegmentLoadMetric, "stop", this, 3)([params]);
      }
      var now = performance.now();
      if (pageLoadData.state === MetricState.STARTED) {
        pageLoadMetaMetric.onStop(function () {
          _superPropGet(PageSegmentLoadMetric, "stop", _this2, 3)([_objectSpread(_objectSpread({}, params), {}, {
            stopTime: params.stopTime || now
          })]);
        }, function () {
          _this2.cancel();
        });
      }
      return true;
    }
  }]);
}(Metric);
_defineProperty(PageSegmentLoadMetric, "FMP", 'fmp');